<template>
  <div class="m-home">
    <Nav :isFixed="bannerFixed"></Nav>
    <Notice></Notice>
    <Bottom class="notice-bottom"></Bottom>
  </div>
</template>
<script>
import Nav from "../components/mobile/m_nav.vue";
import Notice from "../components/pc/notice.vue";
import Bottom from "../components/mobile/m_bottom.vue";
export default {
  data() {
    return {
      bannerFixed: false,
      fullList: {
        cbn: {
          img: require("@/assets/img/cbn.png"),
          title: "CBN Supervision",
          text: "Blue Ridge Microfinance Bank LTD is a microfinance bank supervised by the Central bank of Nigeria(CBN). We are engaged in legal and compliant financial activities in Nigeria, and we regularly submit corresponding product design and operation information to the CBN. Blue Ridge Microfinance Bank APP is an important service method we provide to users. In this way, users can more easily obtain high-quality bank wealth management products and services.",
        },
        insurance: {
          img: require("@/assets/img/insurance.png"),
          title: "Data Protection",
          text: "According to the relevant laws and regulations of the Bank of Nigeria on financial management, we guarantee the data security of each user and will not leak any data to mission agencies.",
        },
        technical: {
          img: require("@/assets/img/mobile/technical.png"),
          title: "Technical Guarantee",
          text: "These technologies include 256 bits SSL security encryption、AES encryption algorithm , etc.",
        },
        interest: {
          img: require("@/assets/img/interest.png"),
          title: "Daily Interest",
          text: "No matter how late, you can enjoy interest on the day the funds are transferred and invested successfully, and the interest will generally arrive after 8 o'clock the next day.The interest that arrives in the account is automatically included in the total investment, and you can earn interest on the next day (compound interest).",
        },
        anytime: {
          img: require("@/assets/img/24.png"),
          title: "Withdraw anytime",
          text: "You can apply for withdrawal at any time, and the withdrawal funds will arrive in your provided bank account within 24-48 hours, so you are not afraid of emergencies.",
        },
      },
    };
  },
  components: {
    Nav,
    Bottom,
    Notice,
  },
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      console.log(window.scrollY);
      if (window.scrollY > 80) {
        this.bannerFixed = true;
      } else {
        this.bannerFixed = false;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/public";
.m-home {
  .full-title {
    width: 1100px;
    font-size: 80px;
    color: #131231;
    @include title;
    margin: 0 auto;
    margin-bottom: 100px;
  }
  .full-div {
    padding: 200px 60px;
    background-color: #fff;
    .cbn {
      padding: 100px 40px 160px;
      background-color: #f5f9ff;
      border-radius: 120px;
      .top-img {
        display: block;
        width: 282px;
        margin: 0 auto;
        margin-bottom: 100px;
      }
      .mainCom-title {
        font-size: 64px;
        color: #131231;
        @include title;
        margin-bottom: 60px;
      }
      .mainCom-text {
        font-size: 52px;
        color: #565d75;
        text-align: center;
      }
      margin-bottom: 160px;
    }
    .bank-doc {
      width: 812px;
      display: block;
      margin: 0 auto;
      margin-bottom: 160px;
    }
  }
  .safety {
    padding: 100px 60px;
    background-color: #f8fafc;
    .top-img {
      width: 192px;
    }
  }
}
.notice-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
